export default __webpack_public_path__ + "static/media/lotuscoateddart.81f332fb.png";